<script setup lang="ts">
interface PhxsgRichTextProps {
  use?: keyof HTMLElementTagNameMap;
}

const { use = 'div' } = defineProps<PhxsgRichTextProps>();
</script>

<template>
  <component :is="use" class="phxsg-rich-text">
    <slot />
  </component>
</template>

<style src="./rich-text.css" />
